// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let React = require("react");
let Form__Input = require("../../uikit/reason/atoms/Form/Form__Input.bs.js");
let JsxRuntime = require("react/jsx-runtime");

function PasswordInput(props) {
  let value = props.value;
  let match = React.useState(() => false);
  let setShowPassword = match[1];
  let showPassword = match[0];
  let tmp = value === "" ? null : JsxRuntime.jsx("button", {
      children: showPassword ? "Hide" : "Show",
      className: "font-semibold text-gray-800 absolute right-3 bottom-2.5",
      type: "button",
      onClick: param => setShowPassword(current => !current)
    });
  return JsxRuntime.jsxs("div", {
    children: [
      JsxRuntime.jsx(Form__Input.make, {
        labelText: "Password",
        type: showPassword ? "text" : "password",
        onChange: props.onChange,
        onBlur: props.onBlur,
        status: props.status,
        value: value
      }),
      tmp
    ],
    className: "relative"
  });
}

let make = PasswordInput;

exports.make = make;
/* react Not a pure module */
